import Layout from "@/layout";

export default {
  path: "/setting",
  component: Layout,
  meta: {title: "Settings", icon: "setting-v2", },
  name: "Setting",
  alwaysShow: true,
  hidden: true,
  children: [
    {
      path: "index",
      name: "basicInfo",
      component: () => import(/* webpackChunkName: "setting-basic-info" */ "@/views/info-v2/views/basicInfo/index.vue"),
      meta: { title: "Basic Info", keepName: 'BasicInfo', keepAlive: true, icon: 'icons-24-line-info' },
    },
    {
      path: "newoperator",
      name: "newoperator",
      component: () =>
        import(/* webpackChunkName: "setting-basic-info" */ "@/views/info-v2/views/basicInfo/addOperator.vue"),
      meta: { activeMenu: '/setting/index' },
      hidden: true
    },
    {
      path: "terminaldetail",
      name: "terminaldetail",
      component: () =>
        import(/* webpackChunkName: "setting-basic-info" */ "@/views/info-v2/views/basicInfo/terminalDetail.vue"),
      hidden: true,
      meta: { activeMenu: '/setting/index' }
    },
    // {
    //   path: "eld",
    //   name: "Integration",
    //   component: () => import(/* webpackChunkName: "setting-eld" */ "@/eld"),
    //   meta: { title: "ELD", icon: 'icons-24-line-eld' },
    // },
    {
      path: "eld",
      name: "eld",
      component: () => import("@/views/eld-v2"),
      meta: { title: "ELD", icon: 'icons-24-line-eld' },
      redirect: "/setting/eld/add-integration",
      children: [
        {
          path: "add-integration",
          name: "Account Integration",
          component: () =>
            import("@/views/eld-v2/views/addIntegration"),
          hidden: true,
          meta: { activeMenu: '/setting/eld' },
        },
        {
          path: "align-drivers",
          name: "Drivers",
          component: () =>
            import("@/views/eld-v2/views/alignDrivers"),
          hidden: true,
          meta: { activeMenu: '/setting/eld' },
        },
        {
          path: "align-trucks",
          name: "Assets",
          component: () =>
            import("@/views/eld-v2/views/alignTrucks"),
          hidden: true,
          meta: { activeMenu: '/setting/eld' },
        }
      ]
    },
    // {
    //   path: 'load-boards',
    //   name: 'LoadBoards',
    //   component: () => import(/* webpackChunkName: "setting-load-boards" */ "@/views/load-boards"),
    //   meta: { title: 'Load Sources' }
    // },
    {
      path: "appearance",
      name: "Tools",
      component: () => import(/* webpackChunkName: "setting-customization" */ "@/views/customization"),
      meta: { title: "Customization", keepName: 'Customization', keepAlive: true, icon: 'icons-24-line-customization' }
    },
    // {
    //   name: 'Payment and Billing',
    //   path: "payment-and-billing",
    //   meta: {
    //     roles: ["admin", "diamond"],
    //     title: "Payment and Billing",
    //   },
    //   component: () => import(
    //       /* webpackChunkName: "setting-subscription" */ "@/views/info-v2/views/subscription"
    //       ),
    //   redirect: '/setting/payment-and-billing/manage',
    //   children: [
    //     {
    //       path: "method",
    //       name: "PaymentMethod",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "setting-subscription" */ "@/views/info-v2/views/subscription/views/payment-method"
    //           ),
    //       hidden: true,
    //       meta: { activeMenu: '/setting/payment-and-billing' },
    //     },
    //     {
    //       path: "manage",
    //       name: "ManageSubscription",
    //       component: () =>
    //         import(
    //           /* webpackChunkName: "setting-subscription" */
    //           "@/views/info-v2/views/subscription/views/manage-subscription"
    //           ),
    //       hidden: true,
    //       meta: { activeMenu: '/setting/payment-and-billing' },
    //     }
    //   ]
    // },
    {
      name: 'Subscription and Billing',
      path: "subscription-and-billing-v2",
      meta: {
        roles: ["admin", "operator", "diamond"],
        title: "Subscription and Billing",
        icon: 'icons-24-line-billing'
      },
      component: () => import("@/views/payment-v3"),
      redirect: '/setting/subscription-and-billing-v2/manage',
      children: [
        {
          path: "manage",
          name: "Subscription3",
          component: () => import("@/views/payment-v3/views/subscription"),
          meta: { activeMenu: '/setting/subscription-and-billing-v2' }
        },
        {
          path: 'assign-subscription',
          name: 'assignSubscription',
          component: () => import('@/views/payment-v3/views/assign-subscription'),
          meta: { activeMenu: '/setting/subscription-and-billing-v2' }
        },
        {
          path: 'billing',
          name: 'Billing',
          component: () => import('@/views/payment-v3/views/billing'),
          meta: { activeMenu: '/setting/subscription-and-billing-v2' }
        },
        {
          path: "dispatch-fee",
          name: "Dispatch Fee",
          component: () => import("@/views/payment-v2/views/dispatch-fee"),
          hidden: true,
          meta: { activeMenu: '/setting/subscription-and-billing-v2' }
        },
      ]
    },
    {
      name: 'Subscription and Billing prev',
      path: "subscription-and-billing",
      hidden: true,
      component: () => import("@/views/info-v2/views/subscription_58"),
      redirect: "/setting/subscription-and-billing/manage",
      children: [
        {
          path: "billing",
          name: "Billing",
          component: () =>
            import(
              /* webpackChunkName: "setting-subscription" */ "@/views/info-v2/views/subscription_58/views/payment-method"
              ),
          hidden: true,
          meta: { activeMenu: '/setting/subscription-and-billing' },
        },
        {
          path: "manage",
          name: "ManageSubscription",
          component: () =>
            import(
              /* webpackChunkName: "setting-subscription" */
              "@/views/info-v2/views/subscription_58/views/manage-subscription"
              ),
          hidden: true,
          meta: { activeMenu: '/setting/subscription-and-billing' },
        },
        {
          path: "dispatch-fee",
          name: "Dispatch Fee",
          component: () =>
            import(
              /* webpackChunkName: "setting-dispatch-fee" */ "@/views/info-v2/views/subscription_58/views/dispatch-fee"
              ),
          hidden: true,
          meta: { activeMenu: '/setting/subscription-and-billing' }
        },
      ]
    },
    {
      path: "add-card",
      name: "SubscriptionAddCard",
      component: () =>
        import(
          /* webpackChunkName: "setting-subscription-add-card" */ "@/views/info-v2/views/add-card"
          ),
      hidden: true,
      meta: { activeMenu: '/setting/payment-and-billing' }
    },
    {
      path: "seats",
      name: "SubscriptionEditSeats",
      component: () =>
        import(
          /* webpackChunkName: "setting-subscription-seats" */ "@/views/info-v2/views/subscription/views/edit-seats"
          ),
      hidden: true,
      meta: { activeMenu: '/setting/payment-and-billing' }
    },
    {
      path: "update-subscription",
      name: "Updatescription",
      component: () => import("@/views/info-v2/views/subscription_58/views/edit-seats"),
      hidden: true,
      meta: { activeMenu: "/setting/subscription-and-billing" },
    },
    {
      path: "update-subscription-v2",
      name: "Updatescriptionv2",
      component: () => import("@/views/payment-v2/views/subscribe"),
      hidden: true,
      meta: { activeMenu: "/setting/subscription-and-billing-v2" },
    },
    {
      path: "guide",
      name: "ELDGuide",
      component: () => import("@/views/guide"),
      hidden: true,
      children: [
        {
          path: "connectWidth",
          name: "ConnectWidth",
          component: () => import("@/views/guide/views/connect"),
        },
        {
          path: "integration",
          name: "IntegrationManagement",
          component: () => import("@/views/guide/views/integration"),
        }
      ]
    },
    {
      path: 'add-loadboard-seats',
      name: 'addLoadBoardSeats',
      component: () => import(
        /* webpackChunkName: "setting-subscription-seats" */ '@/views/tl-premium/seats/add-seats.vue'
      ),
      hidden: true,
      meta: { activeMenu: '/load-board' }
    },
    // {
    //   path: "expense",
    //   name: "expense",
    //   component: () => import("@/views/expense/index.vue"),
    //   meta: { title: "Expense", keepName: 'Expense', keepAlive: true },
    // },
    // {
    //   path: "newexpense",
    //   name: "newexpense",
    //   hidden: true,
    //   component: () => import("@/views/expense/detail.vue"),
    //   meta: { activeMenu: '/setting/expense' },
    // },
  ]
}









